import useLocalStorageState from "use-local-storage-state";

/**
 * Indicates whether testcafe is used to view the page
 */
export default function useTestcafe() {
  const [testcafe] = useLocalStorageState("testcafe", { defaultValue: false });
  return testcafe;
}
